import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Select, notification, Button,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import Helpers from '@Apis/helpers';
import TenantActions from '@Actions/tenantActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TdsTcsActions from '@Actions/configurations/tdsTcsActions';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const TallyTcsAndTdsMapping = ({
  user, tenants, getTallyConnections, tallyConnections, connectTenantToTallyLocation,
  connectTenantToTallyLocationLoading, setStep, getTallyConnectionsLoading,
  stepNumber, getTdsTcs, getTdsTcsLoading, tdsTcs,
}) => {
  const [tcsTdsData, setTcsTdsData] = useState([]);
  const [tcsTdsOptions, setTcsTdsOptions] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState('');
  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));

  useEffect(() => {
    getTallyConnections(user?.tenant_info?.org_id);
    getTdsTcs();
  }, []);

  const tallyConnectionsFilteredData = tallyConnections?.filter((connection) => connection?.it_id === integrationTallyIdURL);

  useEffect(() => {
    setTcsTdsOptions(tallyConnectionsFilteredData[0]?.tcs_and_tds_account_list?.map((item) => ({ ...item, key: uuidv4() })) || []);
    if (tallyConnectionsFilteredData[0]?.tcs_tds_taxes_mapping?.length) {
      setTcsTdsData(tdsTcs?.data?.map((nItem) => {
          const matchedMapping = tallyConnectionsFilteredData?.[0]?.tcs_tds_taxes_mapping?.find((oItem) => (oItem?.tax_id === nItem?.tax_id));
          if (matchedMapping) {
            return {
              ...nItem, key: uuidv4(),
              tally_ledger_name: matchedMapping?.tally_ledger_name,
            }
          }
          return {
            ...nItem, key: uuidv4(),
          }
      }))
    } else {
      setTcsTdsData(tdsTcs?.data?.map((item) => ({ ...item, key: uuidv4(), })));
    }

  }, [tenants, tallyConnections, tdsTcs]);

  const updateTableValue = (key, value, label) => {
    const data = tcsTdsData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTcsTdsData(data);
  };

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data)) : []);

  const columns = [
    {
      title: 'Procuzy Tcs And Tds',
      width: '312px',
      render: (record) => (
        <div>

          {record?.tax_name}
          &nbsp;
          {record?.tax_type_name ? (
            <span style={{ fontSize: '10px' }}>
              (
              {record?.tax_type_name}
              )
            </span>
          ) : ''}
        </div>
      ),
    },
    {
      title: 'Tally Tcs and Tds Ledgers',
      render: (record) => (
        <div className="select__tally__tax">
          <PRZSelect
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tally_ledger_name');
            }}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            value={record.tally_ledger_name}
            hideTitle
            disabled={connectTenantToTallyLocationLoading || getTdsTcsLoading}
          >
            {tcsTdsOptions?.map((tax) => (
              <Option value={tax?.tcs_tds_account_name} key={tax?.key}>
                {tax?.tcs_tds_account_name}
              </Option>
            ))}
          </PRZSelect>
          
        </div>
      ),
    },
  ];


  const handleSubmit = () => {
    setFormSubmitted(true);
    const payload = {
      ...tallyConnectionsFilteredData[0],
      tcs_tds_taxes_mapping: tcsTdsData,
    };

    connectTenantToTallyLocation(payload, () => {
      setStep(stepNumber + 1);
    });
  };

  return (
    <Fragment>
      {(getTallyConnectionsLoading)
        ? (
          <div className="tally-integration__loader__wrapper">

            {[...Array(5).keys()].map((item) => (
              <div key={item} className="tally-integration__loader-row">
                <div className="loadingBlock  tally-integration__loader__line1" />
                <div className="loadingBlock  tally-integration__loader__line2" />
                <div className="loadingBlock  tally-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock tally-integration__loader__line-btn1" />
            <div className="loadingBlock tally-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div>
            <div className="integration-step__wrapper">
              <div className="ant-row">
                <div className="ant-col-md-18">
                  <Table
                    title={() => 'Map TCS and TDS taxes of Procuzy with Tally'}
                    columns={columns}
                    loading={getTallyConnectionsLoading || connectTenantToTallyLocationLoading || getTdsTcsLoading}
                    dataSource={getDataSource(tcsTdsData) || []}
                    size="small"
                    pagination={false}
                  />
                </div>
              </div>
            </div>
            <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
              <Button
                type="primary"
                ghost
                onClick={() => setStep(8)}
                disabled={connectTenantToTallyLocationLoading}
              >
                Back
              </Button>
              &nbsp;&nbsp;
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                disabled={connectTenantToTallyLocationLoading}
                loading={connectTenantToTallyLocationLoading}
              >
                Save and Continue
              </Button>
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, TallyIntegrationReducers, TdsTcsReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
  pullTallyProductsLoading: TallyIntegrationReducers.pullTallyProductsLoading,
  pullTallyVendorsLoading: TallyIntegrationReducers.pullTallyVendorsLoading,
  getTdsTcsLoading: TdsTcsReducers.updateTdsTcsLoading,
  tdsTcs: TdsTcsReducers.tdsTcs,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),
  getTdsTcs: (taxName) => dispatch(TdsTcsActions.getTdsTcs(taxName)),
});

TallyTcsAndTdsMapping.propTypes = {
  user: PropTypes.any,
  getTallyConnectionsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  getTallyConnections: PropTypes.func,
  connectTenantToTallyLocation: PropTypes.func,
  connectTenantToTallyLocationLoading: PropTypes.bool,
  tallyConnections: PropTypes.any,
  setStep: PropTypes.func,
  stepNumber: PropTypes.any,
  getTdsTcs: PropTypes.func,
  getTdsTcsLoading: PropTypes.bool,
  tdsTcs: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyTcsAndTdsMapping));
